<div class="text-center popup-user" [ngClass]="{'account-header': data.header && (data.header.includes('Account') || data.header.includes('Email Required') || data.header.includes('Send Invitation'))}">
  <div mat-dialog-title class="confirmHeader pt-3 pb-0 d-flex justify-content-center">
    <img src="{{data.imagePath}}" alt="Warning" class="lock-unlock-icon">
  </div>
  <div class="d-flex justify-content-center">
    <h1 class="main-line-text m-0">{{data.header}}</h1>
  </div>
  <div mat-dialog-content class="lock-unlock" [ngClass]="{'send-invitation': data.header && (data.header.includes('Send Invitation') || data.header.includes('Email Required'))}">
     <div class="message-wrap">
        <span class="show-password" *ngIf="data.type === 'generate-password'">
          <span class="sub-line-text">{{data.row1value}}</span> 
          <span class="password-text">{{data.row2value}}</span>
        </span>
        <span class="show-password" *ngIf="data.type === 'generate-password-initiate'">
          <span class="sub-line-text">{{data.row1value}}</span>
        </span>
      <div class="user-status-div align-center" *ngIf="data.type === 'lockunlock-user'">
          <span class="sub-line-text">
            {{ data.row1value}}
          </span>
      </div>
      <div class="sub-line-text" *ngIf="data.type === 'mail-sent'">
          <p>{{data.message}}</p>
          <div *ngIf="data.email || data.phone" class="suppor-info">
            <div class="d-flex align-items-center">
              <mat-icon class="vlm-mat-icon">mail</mat-icon>
              <span>{{data.email || 'N/A'}}</span>
            </div>
              <div  class="d-flex align-items-center">
                <mat-icon class="vlm-mat-icon">phone</mat-icon>
                <span>{{data.phone || 'N/A'}}</span>
              </div>
          </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="d-flex justify-content-center align-self-center mb-3">
    <app-button buttonclass="secondary" class="mr-3 popup-btn" [ngClass]="{'d-none': isMessageValid()}" customClass="admin" (click)="closePopup()" mat-dialog-close>Cancel</app-button>

    <app-button buttonclass="primary" [class]="isMessageValid() ? 'single-btn' : 'popup-btn'" customClass="admin" (click)="!isUpdatOnProcess && actionClick()">{{ data.buttonname }}</app-button>
  </div>
</div>
<div class="lock-unlock-user" *ngIf="isUpdatOnProcess">
  <mat-spinner class="labadmin-spinner" [diameter]="50">
  </mat-spinner>
</div>